module.exports = __webpack_public_path__ + "img/draw-polygon.c056a872.svg";